import React from "react";
import TinySlider from "tiny-slider-react";
import "tiny-slider/dist/tiny-slider.css";
function Slider({ items, teasers, labels, size }) {
  const settings = {
    lazyload: false,
    // gutter: size > 1 ? 20 : 0,
    nav: false,
    touch: true,

    autoplay: true,
    autoplayPosition: "top",
    autoplayText: [
      '<i class="fa-solid fa-play"></i>',
      '<i class="fa-solid fa-stop"></i>',
    ],

    controls: true, // remove built-in nav buttons
    controlsPosition: "top",
    controlsText: [
      '<i class="fa-solid fa-arrow-left"></i>',
      '<i class="fa-solid fa-arrow-right"></i>',
    ],

    responsive: {
      0: {
        items: 1,
      },
      480: {
        items: 2,
      },
      768: {
        items: 3,
      },
      1024: {
        items: 4,
      },
    },
    loop: true,
    fixWidth: true,
  };

  return (
    <div>
      <TinySlider settings={settings}>
        {items.length > 0 ? (
          items.map((entity, index) => (
            <div
              key={index}
              dangerouslySetInnerHTML={{
                __html: teasers[entity.nid],
              }}
            />
          ))
        ) : (
          <div className={"no-results p-4 transition-none"}>
            {labels["nothing"]}
          </div>
        )}
      </TinySlider>
    </div>
  );
}

export default Slider;
